// extracted by mini-css-extract-plugin
export default {"logo":"hotel_logo_logo__5JJkk","logoContainer":"hotel_logo_logoContainer__OwRwE"};